import { Maybe } from '@plugins/shared/types';

export const setLoadSlice = ({
  limitOutput,
  ids,
  numberOfLoaded,
  loadLimit,
  preload,
}: {
  /** Is display limiting enabled? */
  limitOutput: boolean;
  ids: string[];
  numberOfLoaded: number;
  loadLimit: number;
  preload: Maybe<number>;
}): string[] => {
  if (!limitOutput) return ids;
  if (!numberOfLoaded) {
    const end = preload && preload > loadLimit ? preload : loadLimit;
    return ids.slice(0, end);
  }
  return ids.slice(0, numberOfLoaded + loadLimit);
};
